// Each person's {{personal_line}} (Phase 4, item 7): the one sentence the shared copy leaves to
// them. Scout writes them; the strategist reads and edits them here before Create.
import type { Contact } from '../api/types';
import { contactDisplay } from '../lib/contactName';

export function SequencePersonalLines({ contacts, lines, locked, filling, onEdit }: {
  contacts: Contact[];
  lines: Record<string, string>;
  locked: boolean;
  filling: string | null;
  onEdit: (contactId: string, text: string) => void;
}) {
  if (!contacts.length) return null;
  return (
    <div className="seqlines">
      {contacts.map(contact => {
        const display = contactDisplay(contact.name, contact.email, 'Unnamed', contact);
        return (
          <label key={contact.id} className="seqline">
            <span className={display.named ? 'pname' : 'pname unnamed'}>{display.text}</span>
            <textarea aria-label={`Personal line for ${display.text}`} rows={2} maxLength={300}
              placeholder={filling === contact.id ? 'Scout is writing…' : 'Personal line'}
              value={lines[contact.id] ?? ''} disabled={locked || filling !== null}
              onChange={event => onEdit(contact.id, event.target.value)} />
          </label>
        );
      })}
    </div>
  );
}
